/**
 * 獲取完整的 URL
 * @param {string} relativePath
 * @returns {string}
 */
const getAssetUrl = (relativePath) => {
  const baseUrl = process.env.REACT_APP_ASSET_URL;
  const version = process.env.REACT_APP_VERSION;
  return `${baseUrl}${relativePath}?ver=${version}`;
};

window.assetUrl = getAssetUrl;

export { getAssetUrl };
